<!-- Filter Popup Start -->
<kendo-dialog title="Filter Options" *ngIf="_reportFilterService.showFilterPopup" (close)="filterClose()"
    class="kendo-modal modal-md">
    <div class="common-popup-space">
        <div class="row">
            <!-- Facility Drop Down -->
            <div class="col-12 col-md-12" *ngIf="FacilityDisplay && !isFacilityUser">
                <div class="form-group">
                    <label class="form-label">Facility</label>
                    <kendo-multiselect [data]="selectFacilityList" [kendoDropDownFilter]="_reportService.filterSettings"
                        [(ngModel)]="_reportFilterService.selectedFacility" [textField]="'text'" [valueField]="'text'"
                        (valueChange)="onValueChange()" [autoClose]="false" class="multiselect-dropdown-height"
                        [ngClass]="{'is-invalid': isFilterSelected && _reportFilterService.selectedFacility?.length == 0}">
                        <ng-template kendoMultiSelectHeaderTemplate>
                            <span style="margin-left:14px">
                                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedFacility"
                                    [indeterminate]="isIndet" (click)="onFacilityFilterClick()" />
                                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllText }}</kendo-label>
                            </span>
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span>
                                <kendo-label for="chk-{{ dataItem.text }}">
                                    <input type="checkbox" id="chk-{{ dataItem.text }}" kendoCheckBox
                                        [checked]="isItemSelected(dataItem)" />
                                </kendo-label>
                            </span>
                            <span>{{ dataItem.text }}</span>
                        </ng-template>
                    </kendo-multiselect>
                    <div *ngIf="isFilterSelected && _reportFilterService.selectedFacility?.length == 0"
                        class="invalid-feedback">
                        Please select facility
                    </div>
                </div>
            </div>
            <!-- Practice Address Drop Down -->
            <div class="col-12 col-md-12" *ngIf="PracticeAddressDisplay">
                <div class="form-group">
                    <label class="form-label">Practice Address</label>
                    <kendo-multiselect [data]="selectPracticeAddressList"
                        [kendoDropDownFilter]="_reportService.filterSettings"
                        [(ngModel)]="_reportFilterService.selectedPracticeAddress" [textField]="'text'"
                        [valueField]="'text'" (valueChange)="onValueChangePracticeAddress()" [autoClose]="false"
                        class="multiselect-dropdown-height"
                        [ngClass]="{'is-invalid': isFilterSelected && _reportFilterService.selectedPracticeAddress?.length == 0}">
                        <ng-template kendoMultiSelectHeaderTemplate>
                            <span style="margin-left:14px">
                                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedPracticeAddress"
                                    [indeterminate]="isIndetPracticeAddress" (click)="onClickPracticeAddress()" />
                                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextPracticeAddress
                                    }}</kendo-label>
                            </span>
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span>
                                <kendo-label for="chk-{{ dataItem.text }}">
                                    <input type="checkbox" id="chk-{{ dataItem.text }}" kendoCheckBox
                                        [checked]="isItemSelectedPracticeAddress(dataItem)" />
                                </kendo-label>
                            </span>
                            <span>{{ dataItem.text }}</span>
                        </ng-template>
                    </kendo-multiselect>
                </div>
            </div>
            <!-- Carrier Drop Down -->
            <div class="col-12 col-md-12" *ngIf="CarrierDisplay">
                <div class="form-group">
                    <label class="form-label">Carrier</label>
                    <kendo-multiselect [data]="selectCarrierList" [kendoDropDownFilter]="_reportService.filterSettings"
                        [(ngModel)]="_reportFilterService.selectedCarrier" [textField]="'text'" [valueField]="'text'"
                        (valueChange)="onValueChangeCarrier()" [autoClose]="false" class="multiselect-dropdown-height"
                        [ngClass]="{'is-invalid': isFilterSelected && _reportFilterService.selectedCarrier?.length == 0}">
                        <ng-template kendoMultiSelectHeaderTemplate>
                            <span style="margin-left:14px">
                                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedCarrier"
                                    [indeterminate]="isIndetCarrier" (click)="onClickCarrier()" />
                                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextCarrier }}</kendo-label>
                            </span>
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span>
                                <kendo-label for="chk-{{ dataItem.text }}">
                                    <input type="checkbox" id="chk-{{ dataItem.text }}" kendoCheckBox
                                        [checked]="isItemSelectedCarrier(dataItem)" />
                                </kendo-label>
                            </span>
                            <span>{{ dataItem.text }}</span>
                        </ng-template>
                    </kendo-multiselect>
                </div>
            </div>
            <!-- LOC Drop Down -->
            <div class="col-12 col-md-12" *ngIf="LOCDisplay">
                <div class="form-group">
                    <label class="form-label">Level Of Care</label>
                    <kendo-multiselect [data]="selectLOCList" [kendoDropDownFilter]="_reportService.filterSettings"
                        [(ngModel)]="_reportFilterService.selectedLOC" [textField]="'text'" [valueField]="'text'"
                        (valueChange)="onValueChangeLOC()" [autoClose]="false" class="multiselect-dropdown-height"
                        [ngClass]="{'is-invalid': isFilterSelected && _reportFilterService.selectedLOC?.length == 0}">
                        <ng-template kendoMultiSelectHeaderTemplate>
                            <span style="margin-left:14px">
                                <input type="checkbox" id="chk" kendoCheckBox [checked]="isCheckedLOC"
                                    [indeterminate]="isIndetLOC" (click)="onClickLOC()" />
                                <kendo-label for="chk">&nbsp;&nbsp;&nbsp;{{ toggleAllTextLOC }}</kendo-label>
                            </span>
                        </ng-template>
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <span>
                                <kendo-label for="chk-{{ dataItem.text }}">
                                    <input type="checkbox" id="chk-{{ dataItem.text }}" kendoCheckBox
                                        [checked]="isItemSelectedLOC(dataItem)" />
                                </kendo-label>
                            </span>
                            <span>{{ dataItem.text }}</span>
                        </ng-template>
                    </kendo-multiselect>
                </div>
            </div>
            <!-- Year Drop Down -->
            <div class="col-12 col-md-12" *ngIf="YearDisplay">
                <div class="form-group">
                    <label class="form-label">Year</label>
                    <kendo-dropdownlist [data]="selectYearList" [(ngModel)]="_reportFilterService.selectedYear"
                        [valuePrimitive]="true" [kendoDropDownFilter]="_reportService.filterSettings"
                        [textField]="'text'" [valueField]="'value'">
                    </kendo-dropdownlist>
                </div>
            </div>
            <!-- Status Drop Down -->
            <div class="col-12 col-md-12" *ngIf="StatusDisplay">
                <div class="form-group">
                    <label class="form-label">Status</label>
                    <kendo-dropdownlist [data]="selectStatusList" [(ngModel)]="_reportFilterService.selectedStatus"
                        [valuePrimitive]="true" [kendoDropDownFilter]="_reportService.filterSettings"
                        [textField]="'text'" [defaultItem]="{ text: 'Select Status', value: null }"
                        [valueField]="'text'">
                    </kendo-dropdownlist>
                </div>
            </div>
            <!-- Render State Drop Down -->
            <div class="col-12 col-md-12" *ngIf="StateDisplay">
                <div class="form-group">
                    <label class="form-label">Rendering State</label>
                    <kendo-dropdownlist [data]="selectStateList" [(ngModel)]="_reportFilterService.selectedState"
                        [valuePrimitive]="true" [kendoDropDownFilter]="_reportService.filterSettings"
                        [textField]="'text'" [defaultItem]="{ text: 'Select State', value: null }"
                        [valueField]="'text'">
                    </kendo-dropdownlist>
                </div>
            </div>
            <!-- Prefix Drop Down -->
            <div class="col-12 col-md-12" *ngIf="PrefixDisplay">
                <div class="form-group">
                    <label class="form-label">Prefix</label>
                    <kendo-dropdownlist [data]="selectPrefixList" [(ngModel)]="_reportFilterService.selectedPrefix"
                        [valuePrimitive]="true" [kendoDropDownFilter]="_reportService.filterSettings"
                        [textField]="'text'" [defaultItem]="{ text: 'Select Prefix', value: null }"
                        [valueField]="'text'">
                    </kendo-dropdownlist>
                </div>
            </div>
            <!-- Date Filter 1 -->
            <div class="col-12 col-md-12" *ngIf="DateFilter1Display">
                <div class="form-group">
                    <label class="form-label">{{LabelDateFilter1}}</label>
                    <kendo-dropdownlist [data]="filterlistItems" [(ngModel)]="_reportFilterService.selectedDateFilter1"
                        (selectionChange)="getDateFilter1Calculation($event)">
                    </kendo-dropdownlist>
                </div>
            </div>
            <div class="col-12 col-md-12" *ngIf="DateFilter1Display && showCalenderDateFilter1">
                <div class="form-group mb-0">
                    <label class="form-label">{{LabelDateFilter1}}</label>
                    <kendo-daterange>
                        <div class="date-range-box">
                            <kendo-dateinput kendoDateRangeStartInput
                                [(ngModel)]="this._reportFilterService.selectedStartDateFilter1"
                                [ngModelOptions]="{standalone: true}"
                                [(value)]="this._reportFilterService.selectedStartDateFilter1"></kendo-dateinput>
                            <span class="dash-range">-</span>
                            <kendo-dateinput kendoDateRangeEndInput
                                [(ngModel)]="this._reportFilterService.selectedEndDateFilter1"
                                [ngModelOptions]="{standalone: true}"
                                [(value)]="this._reportFilterService.selectedEndDateFilter1"></kendo-dateinput>
                        </div>
                        <kendo-daterange-popup>
                            <ng-template kendoDateRangePopupTemplate>
                                <kendo-multiviewcalendar kendoDateRangeSelection
                                    [disabledDates]="_reportService.disabledDates">
                                </kendo-multiviewcalendar>
                            </ng-template>
                        </kendo-daterange-popup>
                    </kendo-daterange>
                </div>
            </div>
            <div class="col-12 col-md-12" *ngIf="DateFilter2Display && showCalenderDateFilter1">
                <div class="form-group mb-0">
                    <label class="form-label">{{LabelDateFilter2}}</label>
                    <kendo-daterange>
                        <div class="date-range-box">
                            <kendo-dateinput kendoDateRangeStartInput
                                [(ngModel)]="this._reportFilterService.selectedStartDateFilter2"
                                [ngModelOptions]="{standalone: true}"
                                [(value)]="this._reportFilterService.selectedStartDateFilter2"></kendo-dateinput>
                            <span class="dash-range">-</span>
                            <kendo-dateinput kendoDateRangeEndInput
                                [(ngModel)]="this._reportFilterService.selectedEndDateFilter2"
                                [ngModelOptions]="{standalone: true}"
                                [(value)]="this._reportFilterService.selectedEndDateFilter2"></kendo-dateinput>
                        </div>
                        <kendo-daterange-popup>
                            <ng-template kendoDateRangePopupTemplate>
                                <kendo-multiviewcalendar kendoDateRangeSelection
                                    [disabledDates]="_reportService.disabledDates">
                                </kendo-multiviewcalendar>
                            </ng-template>
                        </kendo-daterange-popup>
                    </kendo-daterange>
                </div>
            </div>
        </div>
    </div>
    <kendo-dialog-actions class="d-block text-end">
        <button kendoButton type="button" (click)="applyFilter()" class="btn btn-primary btn-md">Apply Filter</button>
        <button kendoButton (click)="filterClose()" class="btn btn-cancel btn-md">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>
<!-- Filter Popup End -->